import classes from "./Header.module.css"
import {Box} from "@mantine/core";
import cx from "clsx";
import {Dayjs} from "dayjs";
import {dayjsToMonthDay} from "../../../../common/utils/times";
import {DashboardIcons} from "../../common/constants";
import commonClasses from "../../../../common/common.module.css"

interface HeaderProps {
    title: string;
    subjectCount: number
    lastSessionStart?: Dayjs
}

export const Header = ({
                           title,
                           subjectCount,
                           lastSessionStart
                       }: HeaderProps) => {
    return (
        <Box className={cx(classes.root, commonClasses.mediumLightBlueGradient90, commonClasses.sbRadius)}>
            <Box className={cx("ntc-row-component ntc-flex-align-center")}>
                <DashboardIcons.templateIcon size={"1.5em"}/>
                <Box ml={"0.5em"} className={cx(classes.title)}>{title}</Box>
            </Box>

            <Box className={cx("ntc-row-component ntc-flex-align-center", classes.subtitle)}>
                <DashboardIcons.activityIcon size={"1.5em"}/>
                <Box ml={"0.25em"} mr={"1em"}>Last Session Started {lastSessionStart ? dayjsToMonthDay(lastSessionStart) : ""}</Box>
                <DashboardIcons.subjectsIcon size={"1em"}/> <Box ml={"0.25em"}>{subjectCount} Subjects</Box>
            </Box>
        </Box>
    );
};